import React from 'react';
import ReactDOM from 'react-dom';

import moment from 'moment';
import { BrowserRouter } from 'react-router-dom';

import 'semantic-ui-css/semantic.min.css';

moment.locale('es');

/** Obtiene un elemento HTML por su id o lanza una excepción si el elemento no se encuentra. */
function obtenerHTMLElementPorId(id: string) {
    const element = document.getElementById(id);
    if (!element) throw new Error(`Elemento HTML de id "${id}" no encontrado`);
    return element;
}

function renderizar(alMontarse?: () => void) {
    const { default: App } = require('src/App') as typeof import('./App');

    ReactDOM.render(
        <BrowserRouter>
            <App alMontarse={alMontarse} />
        </BrowserRouter>,
        obtenerHTMLElementPorId('root'),
    );
}

// Introduce HMR (Hot Module Replacement).
// Webpack ya viene preconfigurado para recargar la página completa en caso
// de que un archivo cambie durante el desarrollo. Con HMR no es necesario
// recargar toda la página sino solo algunos módulos en particular.
// Se configura HMR de tal modo que el componente App se recargará cada
// vez que él o sus dependencias cambien. Solo se habilita si la página se
// carga en Webpack (osea, no en producción).
if (module.hot) {
    module.hot.accept('./App', () => {
        // tslint:disable-next-line: no-console
        console.debug('re-renderizando (HMR)');
        renderizar();
    });
}

// Renderiza y monta toda la aplicación
renderizar(() => {
    // Desactiva el spinner de carga de la página HTML, que se dibuja encima de todo,
    // a fin de que se pueda ver la aplicación. Sin esto se verá la animación hasta
    // el fin de los tiempos.
    obtenerHTMLElementPorId('cargando-spinner').outerHTML = '';
});



// WEBPACK FOOTER //
// ./src/index.tsx